module.exports = __webpack_public_path__ + "media/v1_20200302112034.90a0c08d.mp4";